import { Container } from "@material-ui/core";
import React from "react";

export default () => (
  <Container light style={{ background: "rgba(165, 167, 169, 0.3)", height: 1 }} />
);
